import React from "react";
import { Segment, Label, Form, Icon } from "semantic-ui-react";
import { Player } from "@lottiefiles/react-lottie-player";
import animacion from "../../imagenes/Viaje/NuevoViaje_VerResumen.json";
import { destino, partida } from "../../utils/traductor";

export function VerResumen({
  Titulo,
  Localidad,
  Provincia,
  Pais,
  PartidaUbicacion,
  DestinoUbicacion,
  Kms,
  Min,
  PrecioBase,
}) {
  return (
    <div>
      <Segment style={{ boxShadow: "none", borderColor: "white" }}>
        <Label
          attached="top"
          style={{
            backgroundColor: "rgb(229, 246, 253)",
            color: "rgb(1, 67, 97)",
          }}
        >
          {Titulo}
        </Label>
        <Form.Field>
          <b>{partida}:</b> {PartidaUbicacion}
          <br></br>
          <br></br>
          <b>{destino}:</b> {DestinoUbicacion}
          <br></br>
          <br></br>
          <Form.Field style={{ textAlign: "center" }}>
            <Label
              style={{
                backgroundColor: "white",
                color: "#153B5E",
                borderColor: "#153B5E",
              }}
            >
              <Icon name="map outline" />
              {Kms} Kms
            </Label>
            <Label
              style={{
                backgroundColor: "white",
                color: "#153B5E",
                borderColor: "#153B5E",
              }}
            >
              <Icon name="clock outline" />
              {Min} Min
            </Label>
            <Label
              style={{
                backgroundColor: "white",
                color: "#153B5E",
                borderColor: "#153B5E",
              }}
            >
              <Icon name="dollar sign" />
              {PrecioBase}
            </Label>
          </Form.Field>
          <br></br>
          <Player
            src={animacion}
            className="player"
            loop
            autoplay
            style={{ height: 100 }}
          />
          <br></br>
        </Form.Field>
      </Segment>
    </div>
  );
}
